import React, { Component } from 'react'
import Americane1 from '../../../assets/images/strutture/strutture-di-contenimento/americane/strutture-di-contenimento-americana-angolo-noleggiocampi.jpg'
import Americane2 from '../../../assets/images/strutture/strutture-di-contenimento/americane/strutture-di-contenimento-americana-dettaglio-noleggiocampi.jpg'
import Americane3 from '../../../assets/images/strutture/strutture-di-contenimento/americane/strutture-di-contenimento-americana-incrocio-noleggiocampi.jpg'
import {
  Wrapper,
  Header,
  Title,
  Icon,
  CheckMark,
  Content,
  Left,
  Right,
  Para,
  Table,
  Button,
  Image,
  Thumbnails,
  Thumb,
  Section,
  UList,
  MobileContent,
  TableWrapper,
  MobileBottom,
  Price,
  Heading
} from './InfoCommon'
import { americane } from '../../Pages/Strutture/Contenimento'

const tableContent = [
  ['CALCETTO', '', 'x', 'x'],
  ['BASKET', '', 'x', 'x'],
  ['BEACH VOLLEY', '', '', 'x']
]

const Description = () => {
  return (
    <Section>
      <Para>
        {americane.description}
      </Para>
    </Section>
  )
}

const TableInstance = () => {
  return (
    <React.Fragment>
      <Heading>DISPONIBILE PER</Heading>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th />
              <th>BASE</th>
              <th>PRO</th>
              <th>TOP</th>
            </tr>
          </thead>
          <tbody>
            {tableContent.map((row, i) => {
              return (
                <tr key={i}>
                  {row.map((data, i) => <td key={i} style={{ textAlign: data === 'x' ? 'center' : 'left' }}>{data === 'x' ? <CheckMark /> : data}</td>)}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </TableWrapper>
    </React.Fragment>
  )
}

const ListInstance = () => {
  return (
    <Section>
      <Heading>SCHEDA TECNICA</Heading>
      <UList>
        {americane.technical.map((item, i) => <li key={i}>{item}</li>)}
      </UList>
    </Section>
  )
}

class Slider extends Component {
  state = {
    activeImage: Americane1,
    images: [Americane1, Americane2, Americane3]
  }

  handleImageChange (image) {
    this.setState({ activeImage: image })
  }

  render () {
    return (
      <React.Fragment>
        <Image src={this.state.activeImage} alt='Something' />
        <Thumbnails imgCount={this.state.images.length}>
          {this.state.images.map(image => <Thumb onClick={this.handleImageChange.bind(this, image)} src={image} />)}
        </Thumbnails>
      </React.Fragment>
    )
  }
}

class Americane extends Component {
  closeIconClick () {
    this.props.closeModal()
  }

  render () {
    return (
      <Wrapper>
        <Header>
          <Icon fill='#fff' onClick={this.closeIconClick.bind(this)} />
          <Title>
            AMERICANE
          </Title>
        </Header>
        <Content>
          <Left>
            {/* Image Slider */}
            <Slider />

            {/* Table */}
            <TableInstance />

            {/* Price */}
            <Price>A PARTIRE DA <span style={{ color: '#fca317' }}>600 €</span></Price>
          </Left>
          <Right>
            <div>
              {/* Description of component */}
              <Description />

              {/* Technical info */}
              <ListInstance />
            </div>

            <Button onClick={this.closeIconClick.bind(this)}>CHIUDI</Button>
          </Right>
        </Content>
        {/* Content on mobile */}
        <MobileContent>
          {/* Description of component */}
          <Description />

          {/* Image Slider */}
          <Slider />

          {/* Technical info */}
          <ListInstance />

          {/* Table */}
          <TableInstance />

          <MobileBottom>
            <Price>A PARTIRE DA <span style={{ color: '#fca317' }}>600 €</span></Price>
            <Button onClick={this.closeIconClick.bind(this)}>CHIUDI</Button>
          </MobileBottom>
        </MobileContent>
      </Wrapper>
    )
  }
}

export default Americane



// WEBPACK FOOTER //
// ./src/components/Helpers/Info/Americane.js